var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "hypo_elements/Partials/Image/Image", "swiper"], function (require, exports, Image_1, swiper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    swiper_1 = __importDefault(swiper_1);
    var tabletViewport = 992;
    var swiperMobileMode = Array();
    var swiperActiveSlide = Array();
    var swiperSlideCount = Array();
    $(function () {
        var $swipers;
        $swipers = $('.swiper');
        $swipers.each(function (index, element) {
            var $element = $(element);
            var $swiperid = $element.data('cid') || 0;
            swiperMobileMode[$swiperid] = false;
            swiperActiveSlide[$swiperid] = 0;
            var $mobiletrash = $("#swiper-mobile-" + $swiperid);
            var $fraction = $element.find(".swiper-fraction");
            var $wrapper = $element.find(".swiper-wrapper");
            var $slides = $element.find(".swiper-slide");
            var swiper;
            var winWidth = window.innerWidth;
            swiperMobileMode[$swiperid] = checkMobileMode(winWidth, $slides, $wrapper, $mobiletrash, $swiperid, swiperSlideCount[$swiperid], swiperActiveSlide[$swiperid], $fraction, element, false, swiperMobileMode[$swiperid]);
            swiperSlideCount[$swiperid] = calculateFraction(element, $fraction, swiperActiveSlide[$swiperid]);
            if (swiperMobileMode[$swiperid] || swiperSlideCount[$swiperid] > 1) {
                swiper = initSwiper(element, $swiperid, $fraction);
            }
            else {
                disableSwiper(element);
            }
            /* Umbau bei Viewport-Änderung */
            $(window).on('resize', function () {
                var winWidth = window.innerWidth;
                swiperMobileMode[$swiperid] = checkMobileMode(winWidth, $slides, $wrapper, $mobiletrash, $swiperid, swiperSlideCount[$swiperid], swiperActiveSlide[$swiperid], $fraction, element, swiper, swiperMobileMode[$swiperid]);
            });
        });
    });
    function initSwiper(element, $swiperid, $fraction) {
        /* init Swiper: */
        return new swiper_1.default(element, {
            loop: false,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
            },
            on: {
                slideChange: function (el) {
                    swiperActiveSlide[$swiperid] = el.realIndex;
                    if ($fraction) {
                        $fraction.html("".concat(el.realIndex + 1, " / ").concat(swiperSlideCount[$swiperid]));
                    }
                },
                update: function (el) {
                    el.slideTo(0);
                    swiperSlideCount[$swiperid] = calculateFraction(element, $fraction, 0);
                }
            }
        });
    }
    /**
     *
     * @param element
     */
    function disableSwiper(element) {
        $(element).addClass('noswipe');
        $(element).find(".swiper-fraction").hide();
        $(element).find(".swiper-button-next").hide();
        $(element).find(".swiper-button-prev").hide();
        $(element).find(".swiper-pagination").hide();
    }
    /**
     *
     * @param element
     */
    function enableSwiper(element) {
        $(element).removeClass('noswipe');
        $(element).find(".swiper-fraction").show();
        $(element).find(".swiper-button-next").show();
        $(element).find(".swiper-button-prev").show();
        $(element).find(".swiper-pagination").show();
    }
    /**
     *
     * @param winWidth
     * @param $slides
     * @param $wrapper
     * @param $mobiletrash
     * @param $swiperid
     * @param slideCount
     * @param activeSlide
     * @param $fraction
     * @param element
     * @param swiper
     * @param swiperMobileMode
     */
    function checkMobileMode(winWidth, $slides, $wrapper, $mobiletrash, $swiperid, slideCount, activeSlide, $fraction, element, swiper, swiperMobileMode) {
        if (winWidth <= tabletViewport) {
            if (!swiperMobileMode) {
                $slides.each(function (index, slide) {
                    var $slide = $(slide);
                    var $modus = $wrapper.find('.swiper-slide-container').attr('data-swiper-keep-columns') || 'col';
                    var $cols = $slide.find('.flexibleGrid_' + $modus);
                    $cols.each(function (index, col) {
                        var $col = $(col);
                        var $content = $($col.html());
                        var $newslide = $();
                        if ($modus === 'col') {
                            $newslide = $('<div class="swiper-slide mobile"><div class="swiper-slide-container"><div class="flexibleGrid_row default-gutters"><div class="flexibleGrid_col col-12"></div></div></div></div>');
                        }
                        else {
                            $newslide = $('<div class="swiper-slide mobile"><div class="swiper-slide-container"><div class="' + addClass('flexibleGrid_row default-gutters', $wrapper) + '"></div></div></div>');
                        }
                        var $newcol = $newslide.find('.flexibleGrid_' + $modus);
                        $newcol.append($content);
                        $wrapper.append($newslide);
                        observeImages($newslide);
                    });
                    $slide.appendTo($mobiletrash).addClass('moved');
                });
                swiperMobileMode = true;
                if (swiper) {
                    swiper.update();
                }
                else {
                    enableSwiper(element);
                    initSwiper(element, $swiperid, $fraction);
                }
            }
        }
        else {
            if (swiperMobileMode) {
                $wrapper.empty();
                var $movedslides = $mobiletrash.find('.swiper-slide.moved');
                $movedslides.appendTo($wrapper).removeClass('moved');
                swiperMobileMode = false;
                if (swiper) {
                    swiper.update();
                }
                else {
                    disableSwiper(element);
                }
            }
        }
        return swiperMobileMode;
    }
    /**
     * @param defaults
     * @param object
     */
    function addClass(defaults, object) {
        var selectors = '.' + defaults.split(' ').join('.');
        var defaultClasses = object.find(selectors);
        var returns = $(defaultClasses[0]).attr('class');
        if (typeof returns !== 'undefined') {
            return returns;
        }
        return defaults;
    }
    /**
     *
     * @param element
     * @param $fraction
     * @param activeSlide
     */
    function calculateFraction(element, $fraction, activeSlide) {
        var $slides = $(element).find(".swiper-slide");
        var slideCount = $slides.length;
        if ($fraction) {
            $fraction.html("".concat(activeSlide + 1, " / ").concat(slideCount));
        }
        if (slideCount < 2) {
            disableSwiper(element);
        }
        else {
            enableSwiper(element);
        }
        return slideCount;
    }
    /**
     *
     * @param $newslide
     */
    function observeImages($newslide) {
        var $swiperimages = $newslide.find(".image_placeholder");
        var imageCount = $swiperimages.length;
        var imageContentElement = new Image_1.ImageContentElement(window.devicePixelRatio);
        function updateImage($image) {
            var newImageSrc = imageContentElement.resolveImage($image);
            var newImage = new Image();
            newImage.onload = function () {
                $image.attr("src", newImageSrc);
                $image.addClass("image_placeholder--is-faded-in");
            };
            newImage.src = newImageSrc;
        }
        function onIntersect(entries, observer) {
            if (imageCount === 0) {
                observer.disconnect();
            }
            entries.forEach(function (entry) {
                if (entry.intersectionRatio > 0) {
                    imageCount--;
                    observer.unobserve(entry.target);
                    updateImage($(entry.target));
                }
            });
        }
        var observer = new IntersectionObserver(onIntersect, {
            rootMargin: "50px 0px",
            threshold: 0.01,
        });
        $swiperimages.each(function (index, image) {
            observer.observe(image);
        });
    }
});
